var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-records", on: { click: _vm.closeContextMenu } },
    [
      _vm.ctrlPressed
        ? _c(
            "div",
            {
              staticStyle: {
                position: "fixed",
                top: "10px",
                right: "10px",
                background: "#1890ff",
                color: "white",
                padding: "8px",
                "border-radius": "4px",
                "z-index": "9999",
                "font-size": "12px",
              },
            },
            [
              _c("div", [
                _vm._v(
                  _vm._s(_vm.isMac ? "Command (⌘)" : "Ctrl") +
                    " " +
                    _vm._s(_vm.$t("table.keyPressed"))
                ),
              ]),
              _vm._v(" "),
              _c("div", [_vm._v(_vm._s(_vm.$t("table.recordTabModeActive")))]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.altPressed
        ? _c(
            "div",
            {
              staticStyle: {
                position: "fixed",
                top: "10px",
                right: "10px",
                background: "#52c41a",
                color: "white",
                padding: "8px",
                "border-radius": "4px",
                "z-index": "9999",
                "font-size": "12px",
                "margin-top": "60px",
              },
            },
            [
              _c("div", [
                _vm._v(
                  _vm._s(_vm.isMac ? "Option (⌥)" : "Alt") +
                    " " +
                    _vm._s(_vm.$t("table.keyPressed"))
                ),
              ]),
              _vm._v(" "),
              _c("div", [
                _vm._v(_vm._s(_vm.$t("table.recordWindowModeActive"))),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.groupedData, function (groupItem, gIndex) {
        return _c(
          "div",
          {
            key: "group-" + gIndex + "-" + _vm.getGroupHash(groupItem),
            staticClass: "group-container",
          },
          [
            _vm.groupValue.fieldId && groupItem.key && groupItem.key !== "N/A"
              ? _c(
                  "div",
                  {
                    staticClass: "table-row group-header-row",
                    style: { backgroundColor: _vm.getGroupColor(gIndex) },
                    on: {
                      click: function ($event) {
                        return _vm.toggleGroup(gIndex)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "table-cell group-header-cell",
                        attrs: { colspan: _vm.visibleFields.length + 1 },
                      },
                      [
                        _c("i", { staticClass: "material-icons group-icon" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.isGroupExpanded(gIndex)
                                  ? "expand_more"
                                  : "chevron_right"
                              ) +
                              "\n                "
                          ),
                        ]),
                        _vm._v(
                          "\n                " +
                            _vm._s(groupItem.key) +
                            "\n            "
                        ),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isGroupExpanded(gIndex),
                    expression: "isGroupExpanded(gIndex)",
                  },
                ],
                staticClass: "group-content",
              },
              [
                _c("VirtualScroller", {
                  ref: "virtualScroller",
                  refInFor: true,
                  staticClass: "scroller-container",
                  attrs: {
                    items: groupItem.records,
                    "item-size": 41,
                    "key-field": "_id",
                    loading: _vm.loading,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (ref) {
                          var record = ref.item
                          return [
                            _c(
                              "div",
                              {
                                staticClass: "table-row",
                                class: {
                                  selected:
                                    _vm.isSelectionModeActive &&
                                    _vm.isSelected(record._id),
                                  "zebra-row":
                                    _vm.zebraStripes &&
                                    !_vm.groupValue.fieldId &&
                                    groupItem.records.indexOf(record) % 2 === 1,
                                  "selection-mode": _vm.isSelectionModeActive,
                                  "ctrl-hover": _vm.ctrlPressed,
                                  "alt-hover": _vm.altPressed,
                                },
                                style: {
                                  backgroundColor: _vm.getRecordColor(record),
                                },
                                attrs: {
                                  id: "record-" + record._id,
                                  "data-record-id": record._id,
                                },
                                on: {
                                  mouseover: function ($event) {
                                    !_vm.isSelectionModeActive &&
                                      _vm.showCheckbox(record._id)
                                  },
                                  mouseleave: function ($event) {
                                    !_vm.isSelectionModeActive &&
                                      _vm.hideCheckbox(record._id)
                                  },
                                  click: function ($event) {
                                    return _vm.handleRowClick($event, record)
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "table-cell record-id-cell",
                                    style: {
                                      minWidth:
                                        _vm.getColumnWidth("record-id") + "px",
                                      maxWidth:
                                        _vm.getColumnWidth("record-id") + "px",
                                    },
                                  },
                                  [
                                    _vm.pickerMode
                                      ? [
                                          _c(
                                            "a-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                size: "small",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.$emit(
                                                    "record-selected",
                                                    record
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    _vm.$t("table.select")
                                                  ) +
                                                  "\n                                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      : [
                                          !_vm.isSelectionModeActive &&
                                          !_vm.isCheckboxVisible(record._id)
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "record-id-cell-container",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "left" },
                                                    [
                                                      !_vm.pickerMode
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "count-badges",
                                                            },
                                                            [
                                                              record.commentCount >
                                                              0
                                                                ? _c(
                                                                    "a-badge",
                                                                    {
                                                                      staticClass:
                                                                        "count-badge",
                                                                      attrs: {
                                                                        count:
                                                                          record.commentCount,
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            _vm.isSelectionModeActive
                                                                              ? _vm
                                                                                  .$
                                                                                  .noop
                                                                              : _vm.viewRecord(
                                                                                  record,
                                                                                  "comments"
                                                                                )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "a-icon",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              type: "message",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              record.taskCount >
                                                              0
                                                                ? _c(
                                                                    "a-badge",
                                                                    {
                                                                      staticClass:
                                                                        "count-badge",
                                                                      attrs: {
                                                                        count:
                                                                          record.taskCount,
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            _vm.isSelectionModeActive
                                                                              ? _vm
                                                                                  .$
                                                                                  .noop
                                                                              : _vm.viewRecord(
                                                                                  record,
                                                                                  "tasks"
                                                                                )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "a-icon",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              type: "check-circle",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  )
                                                                : _vm._e(),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "middle" },
                                                    [
                                                      _vm._v(
                                                        "\n                                        " +
                                                          _vm._s(
                                                            record.recordId
                                                          ) +
                                                          "\n                                    "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("div", {
                                                    staticClass: "right",
                                                  }),
                                                ]
                                              )
                                            : _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "record-id-cell-container",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "left" },
                                                    [
                                                      !_vm.isSelectionModeActive &&
                                                      !_vm.pickerMode
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "count-badges",
                                                            },
                                                            [
                                                              record.commentCount >
                                                              0
                                                                ? _c(
                                                                    "a-badge",
                                                                    {
                                                                      staticClass:
                                                                        "count-badge",
                                                                      attrs: {
                                                                        count:
                                                                          record.commentCount,
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.viewRecord(
                                                                              record,
                                                                              "comments"
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "a-icon",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              type: "message",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              record.taskCount >
                                                              0
                                                                ? _c(
                                                                    "a-badge",
                                                                    {
                                                                      staticClass:
                                                                        "count-badge",
                                                                      attrs: {
                                                                        count:
                                                                          record.taskCount,
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.viewRecord(
                                                                              record,
                                                                              "tasks"
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "a-icon",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              type: "check-circle",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  )
                                                                : _vm._e(),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "middle" },
                                                    [
                                                      _c("a-checkbox", {
                                                        attrs: {
                                                          checked:
                                                            _vm.isSelected(
                                                              record._id
                                                            ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleCheckboxChange(
                                                              $event,
                                                              record._id
                                                            )
                                                          },
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                          },
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "right" },
                                                    [
                                                      !_vm.isSelectionModeActive
                                                        ? _c(
                                                            "SupsisButton",
                                                            {
                                                              attrs: {
                                                                ghost: "",
                                                                primary: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.viewRecord(
                                                                      record
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "i",
                                                                {
                                                                  staticClass:
                                                                    "material-icons",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "open_in_new"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                "\n                                            " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "modules.viewRecord"
                                                                    )
                                                                  ) +
                                                                  "\n                                        "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      !_vm.isSelectionModeActive &&
                                                      _vm.isSupsisAgentsTable()
                                                        ? _c(
                                                            "SupsisButton",
                                                            {
                                                              attrs: {
                                                                ghost: "",
                                                                primary: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.sendOpenChatBubbleRequest(
                                                                      record
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "i",
                                                                {
                                                                  staticClass:
                                                                    "material-icons",
                                                                },
                                                                [_vm._v("chat")]
                                                              ),
                                                              _vm._v(
                                                                "\n                                            " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "table.supsisAgentChat"
                                                                    )
                                                                  ) +
                                                                  "\n                                        "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      !_vm.isSelectionModeActive &&
                                                      _vm.isSupsisAgentsTable()
                                                        ? _c(
                                                            "SupsisButton",
                                                            {
                                                              attrs: {
                                                                ghost: "",
                                                                primary: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.openPanelBehindOfUser(
                                                                      record
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "i",
                                                                {
                                                                  staticClass:
                                                                    "material-icons",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "login"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                "\n                                            " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "table.supsisAgentLogin"
                                                                    )
                                                                  ) +
                                                                  "\n                                        "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                        ],
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.visibleFields,
                                  function (field, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: field._id + "-" + record._id,
                                        staticClass:
                                          "table-cell table-cell-outer",
                                        class: {
                                          active: _vm.isActiveCell(
                                            record._id,
                                            field._id
                                          ),
                                        },
                                        style: {
                                          minWidth:
                                            _vm.getColumnWidth(field._id) +
                                            "px",
                                          maxWidth:
                                            _vm.getColumnWidth(field._id) +
                                            "px",
                                        },
                                        attrs: {
                                          tabindex: "0",
                                          "data-field-type": field.fieldType,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.setActiveCell(
                                              record._id,
                                              field._id
                                            )
                                          },
                                          keydown: [
                                            function ($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "tab",
                                                  9,
                                                  $event.key,
                                                  "Tab"
                                                )
                                              ) {
                                                return null
                                              }
                                              if (
                                                $event.ctrlKey ||
                                                $event.shiftKey ||
                                                $event.altKey ||
                                                $event.metaKey
                                              ) {
                                                return null
                                              }
                                              $event.preventDefault()
                                              return _vm.moveToNextCell(
                                                record._id,
                                                index
                                              )
                                            },
                                            function ($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              if (
                                                $event.ctrlKey ||
                                                $event.shiftKey ||
                                                $event.altKey ||
                                                $event.metaKey
                                              ) {
                                                return null
                                              }
                                              $event.preventDefault()
                                              return _vm.editCell(
                                                record._id,
                                                field._id
                                              )
                                            },
                                          ],
                                          contextmenu: function ($event) {
                                            $event.preventDefault()
                                            return _vm.onCellContextMenu(
                                              $event,
                                              field,
                                              record
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm.loading
                                          ? _c("LoadingCell", {
                                              attrs: {
                                                fieldType: field.fieldType,
                                              },
                                            })
                                          : [
                                              "text",
                                              "long-text",
                                              "email",
                                              "url",
                                              "phone",
                                              "ai",
                                              "record_id",
                                            ].includes(field.fieldType)
                                          ? _c("StringCell", {
                                              ref: "stringCells",
                                              refInFor: true,
                                              attrs: {
                                                record: record,
                                                field: field,
                                                readonly:
                                                  _vm.pickerMode ||
                                                  _vm.isRecordMetaField(
                                                    field.fieldType
                                                  ),
                                                "ai-mode":
                                                  field.fieldType === "ai",
                                              },
                                              on: {
                                                "update-record": function (
                                                  $event
                                                ) {
                                                  return _vm.updateRecord(
                                                    $event
                                                  )
                                                },
                                              },
                                            })
                                          : field.fieldType === "checkbox"
                                          ? _c("CheckboxCell", {
                                              attrs: {
                                                record: record,
                                                field: field,
                                                readonly: _vm.pickerMode,
                                              },
                                              on: {
                                                "update-record": function (
                                                  $event
                                                ) {
                                                  return _vm.updateRecord(
                                                    $event
                                                  )
                                                },
                                              },
                                            })
                                          : field.fieldType === "number"
                                          ? _c("NumberCell", {
                                              attrs: {
                                                record: record,
                                                field: field,
                                                readonly: _vm.pickerMode,
                                              },
                                              on: {
                                                "update-record": function (
                                                  $event
                                                ) {
                                                  return _vm.updateRecord(
                                                    $event
                                                  )
                                                },
                                              },
                                            })
                                          : field.fieldType === "currency"
                                          ? _c("CurrencyCell", {
                                              attrs: {
                                                record: record,
                                                field: field,
                                                readonly: _vm.pickerMode,
                                              },
                                              on: {
                                                "update-record": function (
                                                  $event
                                                ) {
                                                  return _vm.updateRecord(
                                                    $event
                                                  )
                                                },
                                              },
                                            })
                                          : field.fieldType === "dropdown"
                                          ? _c("DropdownCell", {
                                              attrs: {
                                                record: record,
                                                field: field,
                                                readonly: _vm.pickerMode,
                                              },
                                              on: {
                                                "update-record": function (
                                                  $event
                                                ) {
                                                  return _vm.updateRecord(
                                                    $event
                                                  )
                                                },
                                              },
                                            })
                                          : [
                                              "datetime",
                                              "record_created_at",
                                              "record_updated_at",
                                            ].includes(field.fieldType)
                                          ? _c("DateCell", {
                                              attrs: {
                                                record: record,
                                                field: field,
                                                readonly:
                                                  _vm.pickerMode ||
                                                  _vm.isRecordMetaField(
                                                    field.fieldType
                                                  ),
                                              },
                                              on: {
                                                "update-record": function (
                                                  $event
                                                ) {
                                                  return _vm.updateRecord(
                                                    $event
                                                  )
                                                },
                                              },
                                            })
                                          : field.fieldType ===
                                            "automation-button"
                                          ? _c("ButtonCell", {
                                              attrs: {
                                                record: record,
                                                field: field,
                                                tableId: _vm.table._id,
                                                readonly: _vm.pickerMode,
                                              },
                                              on: {
                                                "update-record": function (
                                                  $event
                                                ) {
                                                  return _vm.updateRecord(
                                                    $event
                                                  )
                                                },
                                              },
                                            })
                                          : [
                                              "file",
                                              "video",
                                              "image",
                                              "audio",
                                            ].includes(field.fieldType)
                                          ? _c("AssetCell", {
                                              attrs: {
                                                record: record,
                                                field: field,
                                                readonly: _vm.pickerMode,
                                              },
                                              on: {
                                                "update-record": function (
                                                  $event
                                                ) {
                                                  return _vm.updateRecord(
                                                    $event
                                                  )
                                                },
                                              },
                                            })
                                          : [
                                              "multi-file",
                                              "multi-video",
                                              "multi-image",
                                              "multi-audio",
                                            ].includes(field.fieldType)
                                          ? _c("MultiAssetCell", {
                                              attrs: {
                                                record: record,
                                                field: field,
                                                readonly: _vm.pickerMode,
                                              },
                                              on: {
                                                "update-record": function (
                                                  $event
                                                ) {
                                                  return _vm.updateRecord(
                                                    $event
                                                  )
                                                },
                                              },
                                            })
                                          : [
                                              "user",
                                              "record_created_by",
                                              "record_updated_by",
                                            ].includes(field.fieldType)
                                          ? _c("UserCell", {
                                              attrs: {
                                                record: record,
                                                field: field,
                                                readonly:
                                                  _vm.pickerMode ||
                                                  _vm.isRecordMetaField(
                                                    field.fieldType
                                                  ),
                                              },
                                              on: {
                                                "update-record": function (
                                                  $event
                                                ) {
                                                  return _vm.updateRecord(
                                                    $event
                                                  )
                                                },
                                              },
                                            })
                                          : field.fieldType === "contact"
                                          ? _c("ContactCell", {
                                              attrs: {
                                                record: record,
                                                field: field,
                                                readonly: _vm.pickerMode,
                                              },
                                              on: {
                                                "update-record": function (
                                                  $event
                                                ) {
                                                  return _vm.updateRecord(
                                                    $event
                                                  )
                                                },
                                              },
                                            })
                                          : field.fieldType === "conversation"
                                          ? _c("ConversationCell", {
                                              attrs: {
                                                record: record,
                                                field: field,
                                                readonly: _vm.pickerMode,
                                              },
                                              on: {
                                                "update-record": function (
                                                  $event
                                                ) {
                                                  return _vm.updateRecord(
                                                    $event
                                                  )
                                                },
                                                "view-conversation": function (
                                                  $event
                                                ) {
                                                  return _vm.openConversationHistory(
                                                    $event
                                                  )
                                                },
                                              },
                                            })
                                          : field.fieldType === "linked-record"
                                          ? _c("LinkedRecordCell", {
                                              attrs: {
                                                record: record,
                                                field: field,
                                                readonly: _vm.pickerMode,
                                              },
                                              on: {
                                                "update-record": function (
                                                  $event
                                                ) {
                                                  return _vm.updateRecord(
                                                    $event
                                                  )
                                                },
                                              },
                                            })
                                          : field.fieldType === "task"
                                          ? _c("TaskCell", {
                                              attrs: {
                                                record: record,
                                                field: field,
                                                readonly: _vm.pickerMode,
                                              },
                                              on: {
                                                "update-record": function (
                                                  $event
                                                ) {
                                                  return _vm.updateRecord(
                                                    $event
                                                  )
                                                },
                                              },
                                            })
                                          : field.fieldType === "json"
                                          ? _c("JsonCell", {
                                              attrs: {
                                                record: record,
                                                field: field,
                                                readonly: _vm.pickerMode,
                                              },
                                              on: {
                                                "update-record": function (
                                                  $event
                                                ) {
                                                  return _vm.updateRecord(
                                                    $event
                                                  )
                                                },
                                              },
                                            })
                                          : field.fieldType === "formula"
                                          ? _c("FormulaCell", {
                                              attrs: {
                                                record: record,
                                                field: field,
                                                table: _vm.table,
                                              },
                                            })
                                          : field.fieldType === "lookup"
                                          ? _c("LookupCell", {
                                              attrs: {
                                                record: record,
                                                field: field,
                                              },
                                            })
                                          : _c(
                                              "div",
                                              {
                                                staticClass: "table-cell-inner",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                " +
                                                    _vm._s(
                                                      _vm.getFieldValue(
                                                        record,
                                                        field._id
                                                      )
                                                    ) +
                                                    "\n                            "
                                                ),
                                              ]
                                            ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
                _vm._v(" "),
                _c("TableFooterSummary", {
                  key: "summary-" + _vm.getGroupHash(groupItem),
                  staticClass: "summary-container",
                  attrs: {
                    records: groupItem.records,
                    visibleFields: _vm.visibleFields,
                    columnWidths: _vm.columnWidths,
                  },
                }),
              ],
              1
            ),
          ]
        )
      }),
      _vm._v(" "),
      _vm.contextMenuVisible && _vm.globalContextMenu
        ? _c(
            "div",
            {
              staticClass: "global-context-menu",
              style: {
                left: _vm.contextMenuX + "px",
                top: _vm.contextMenuY + "px",
              },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "context-menu" },
                [
                  _vm._l(
                    _vm.getQuickFilterActions(
                      _vm.contextMenuField,
                      _vm.contextMenuRecord
                    ),
                    function (action) {
                      return _c(
                        "div",
                        {
                          key: action.operator + "-" + (action.key || ""),
                          staticClass: "context-menu-item",
                          class: {
                            active: _vm.isQuickFilterActionActive(action),
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.onQuickFilterActionClick(action)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "item-left" }, [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v(_vm._s(action.icon || "filter_alt")),
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(action.label))]),
                          ]),
                          _vm._v(" "),
                          _vm.isQuickFilterActionActive(action)
                            ? _c(
                                "i",
                                { staticClass: "material-icons active-icon" },
                                [_vm._v("check")]
                              )
                            : _vm._e(),
                        ]
                      )
                    }
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "context-menu-item danger",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.clearAllFilters.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("clear_all"),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("table.clearAllQuickFilters"))),
                      ]),
                    ]
                  ),
                ],
                2
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showConversationHistory && _vm.activeConversation
        ? _c("UserChatHistoryWidget", {
            attrs: {
              "visitor-id": _vm.activeConversation.visitor,
              "conversation-id": _vm.activeConversation._id,
            },
            on: { close: _vm.closeConversationHistory },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }